import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import CustomCountrySelect from './CustomCountrySelect';

export default function PhoneInputField({ value, onChange, isValid, submitted }) {
    return (
        <div className="phoneInputWrapper">
            <label className="phoneInput__label">Telefono numeris</label>
            <PhoneInput
                defaultCountry="LT"
                value={value}
                onChange={onChange}
                countrySelectComponent={CustomCountrySelect}
                numberInputProps={{
                    placeholder: 'Įveskite numerį',
                    className: 'phoneInput',
                    autoComplete: 'off'
                }}
            />
            {submitted && !isValid && (
                <div style={{ color: 'red', marginTop: 4 }}>Neteisingas telefono numeris</div>
            )}
        </div>
    );
}
